import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-approvals-validation',
  templateUrl: './approvals-validation.component.html',
  styleUrls: ['./approvals-validation.component.scss'],
})
export class ApprovalsValidationComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    //
  }
}
